import type { Category } from "./category";

// 默认分类数据（当无法从后端获取分类信息时使用）
export const DEFAULT_CATEGORY_DATA: Category = {
  title: "Please Select Service Category",
  desc: "Choose the type of issue you want to inquire about, and we will provide you with more precise service",
  configs: [
    {
      icon: "CreditCardOutlined",
      name: "Deposit",
      description: "Deposit related inquiries",
      replyContent: ["deposit_guide", "payment_methods"],
      color: "#52c41a",
    },
    {
      icon: "BankOutlined",
      name: "Withdrawal",
      description: "Withdrawal related inquiries",
      replyContent: ["withdraw_guide", "withdraw_fees"],
      color: "#1890ff",
    },
    {
      icon: "SafetyOutlined",
      name: "Login/OTP",
      description: "Login and verification code related issues",
      replyContent: ["login_help", "otp_guide"],
      color: "#fa8c16",
    },
    {
      icon: "IdcardOutlined",
      name: "KYC",
      description: "Identity verification related issues",
      replyContent: ["kyc_guide", "verification_process"],
      color: "#722ed1",
    },
    {
      icon: "GiftOutlined",
      name: "Welfare & Others",
      description: "Welfare activities and other issues",
      replyContent: ["promotions", "general_help"],
      color: "#eb2f96",
    },
  ],
};
